import { BookOpen, ArrowUpRight } from "lucide-react"

interface SourceItem {
  label: string
  url: string
  publisher?: string
}

interface PillarSourcesProps {
  items: SourceItem[]
  heading?: string
  className?: string
}

export function PillarSources({
  items,
  heading = "Sources",
  className,
}: PillarSourcesProps) {
  if (!items.length) return null
  return (
    <section
      aria-label={heading}
      className={
        className ??
        "mt-4 rounded-2xl border border-gray-200 bg-white px-5 py-5 md:px-7 md:py-6"
      }
    >
      <div className="mb-4 flex items-center gap-2">
        <BookOpen
          className="h-4 w-4 text-gray-400"
          strokeWidth={2.2}
          aria-hidden="true"
        />
        <h2 className="m-0 text-[11px] font-bold uppercase tracking-[0.1em] text-gray-500">
          {heading}
        </h2>
      </div>
      <ol className="m-0 flex flex-col gap-3 p-0 list-none">
        {items.map((s, i) => (
          <li key={s.url} className="flex items-start gap-3">
            <span
              aria-hidden="true"
              className="mt-px inline-flex h-5 w-5 flex-none items-center justify-center rounded-full bg-emerald-50 text-[11px] font-bold text-emerald-700 ring-1 ring-emerald-100 ring-inset"
            >
              {i + 1}
            </span>
            <div className="flex flex-col gap-0.5 text-[14px] leading-snug md:text-[15px]">
              {s.publisher ? (
                <span className="font-semibold text-gray-900">{s.publisher}</span>
              ) : null}
              <a
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-baseline gap-1 text-gray-600 underline-offset-2 hover:text-emerald-700 hover:underline"
              >
                <span>{s.label}</span>
                <ArrowUpRight
                  className="h-3 w-3 flex-none text-gray-400 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-emerald-600"
                  strokeWidth={2.4}
                  aria-hidden="true"
                />
              </a>
            </div>
          </li>
        ))}
      </ol>
    </section>
  )
}
